import { createSlice } from "@reduxjs/toolkit";

let initialState: {
  sidebarMiniActive: boolean;
  mobileOpen: boolean;
  vestiging: { country: string; [k: string]: any } | null;
} = {
  sidebarMiniActive: false,
  mobileOpen: false,
  vestiging: null,
};
const serializedState = localStorage.getItem("redux.app");
if (serializedState !== null) {
  try {
    initialState = JSON.parse(serializedState);
  } catch (err) {}
}

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    toggle_sidebar: (state) => {
      const newState = {
        ...state,
        sidebarMiniActive: !state.sidebarMiniActive,
      };
      localStorage.setItem("redux.app", JSON.stringify(newState));
      return newState;
    },
    toggle_mobile: (state) => {
      const newState = {
        ...state,
        mobileOpen: !state.mobileOpen,
        sidebarMiniActive: false,
      };
      localStorage.setItem("redux.app", JSON.stringify(newState));
      return newState;
    },
    set_vestiging: (state, action: { vestiging: any }) => {
      const newState = {
        ...state,
        vestiging: action.vestiging,
      };
      localStorage.setItem("redux.app", JSON.stringify(newState));
      return newState;
    },
  },
});

export default appSlice.reducer;
